import React from 'react';
import './styles.css';

const NumberField = props => {
  const focusNextInput = e => {
    let value = e.target.value.replace(/\s+/g, '');
    if (value.length > 6) value = props.value;
    props.onChange(value);
  };

  return (
    <form className="number-field">
      <input
        onChange={focusNextInput}
        type="number"
        value={props.value}
        className="number-field__input"
        placeholder="——————"
      />

      <button
        onClick={props.onSubmit}
        className="number-field__btn click-animate"
      >
        {props.btnText}
      </button>
    </form>
  );
};

export default NumberField;
